import {CONTENT_MAX_WIDTH, DRAWER_WIDTH, TOOLBAR_HEIGHT, TOOLBAR_HEIGHT_XS, withMediaQueries} from "src/styles/Styles";
import {AppBar, makeStyles} from "@material-ui/core";
import {ColorBackground, ColorBackgroundXS, ColorCard, ColorNav, ColorUIChecker1} from "src/styles/Colors";
import React from "react";
import TextView from "./TextView";
import {FontWeightMedium} from "src/res/FontWeight";
import {NavActionView, NavBackActionView} from "./ViewHelper";
import {IconMore} from "./AppIcon";
import zIndex from "@material-ui/core/styles/zIndex";
import auth from "src/js/utils/auth";

const useStyles = makeStyles((theme) => ({
  appBar: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    flex: 1,
    minHeight: TOOLBAR_HEIGHT,
    height: TOOLBAR_HEIGHT,
    paddingLeft: DRAWER_WIDTH,
    paddingRight: 0,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: ColorBackground,
    [theme.breakpoints.down('sm')]: {
      paddingLeft: 0,
    },
    [theme.breakpoints.down('xs')]: {
      minHeight: TOOLBAR_HEIGHT_XS,
      height: TOOLBAR_HEIGHT_XS,
      backgroundColor: ColorBackgroundXS
    },
    zIndex: zIndex.drawer - 1
  },
  appBarReadOnly: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    flex: 1,
    minHeight: TOOLBAR_HEIGHT,
    height: TOOLBAR_HEIGHT,
    paddingLeft: 0,
    paddingRight: 0,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: ColorBackground,
    [theme.breakpoints.down('sm')]: {
      paddingLeft: 0,
    },
    [theme.breakpoints.down('xs')]: {
      minHeight: TOOLBAR_HEIGHT_XS,
      height: TOOLBAR_HEIGHT_XS,
      backgroundColor: ColorBackgroundXS
    },
    zIndex: zIndex.drawer - 1
  },
  appBarIn: {
    display: 'flex',
    flexDirection: 'row',
    flex: 1,
    height: TOOLBAR_HEIGHT,
    justifyContent: 'flex-start',
    alignItems: 'center',
    paddingLeft: 24,
    paddingRight: 24,
    maxWidth: CONTENT_MAX_WIDTH,
    [theme.breakpoints.only('sm')]: {
      paddingLeft: 68,
      paddingRight: 68,
      justifyContent: 'center',
    },
    [theme.breakpoints.down('xs')]: {
      height: TOOLBAR_HEIGHT_XS,
      paddingLeft: 54,
      paddingRight: 54,
      justifyContent: 'center'
    },
  },
  titleContainer: {
    display: 'flex',
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    [theme.breakpoints.only('sm')]: {
      paddingLeft: 68,
      paddingRight: 68,
      justifyContent: 'center',
    },
    [theme.breakpoints.down('xs')]: {
      paddingLeft: 54,
      paddingRight: 54,
      justifyContent: 'center'
    },
  },
}))

const HeaderTitleView = (props) => {
  const {titleId, title, isLTR, isXS, onBackClicked, onMoreClicked} = props;
  const classes = useStyles();

  // const className = auth.isAuthenticated() ? classes.appBar : classes.appBarReadOnly;
  const className = classes.appBar;
  return (
    <AppBar
      elevation={0}
      className={className}
      position="fixed">
      <div className={classes.appBarIn}>
        {onBackClicked ?
          <div style={{marginLeft: isLTR ? -13 : 8, marginRight: isLTR ? 8 : -13}}>
            <NavBackActionView isLTR={isLTR} onClick={onBackClicked} style={{backgroundColor: ColorCard}}/>
          </div>
          : null
        }
        <div className={classes.titleContainer}>
          {titleId || title ? <TextView textAlign={'center'} variant={isXS ? "body1" : "h6"} textId={titleId} text={title} color={ColorNav} fontWeight={FontWeightMedium} /> : null}
        </div>
        {onMoreClicked ?
          <NavActionView isLTR={isLTR} icon={IconMore} onClick={onMoreClicked}/>
          : null
        }
      </div>
    </AppBar>
  );
};

export default HeaderTitleView;
